import { useContext, useEffect, useState } from 'react';
import { ApiGetCDNData } from '../JS/Connector';
import ImagesPopup from './ImagesPopup';
import { log } from '../JS/Logger';
import { useSelector } from 'react-redux';
import useConfig from '../Hooks/useConfig';
export default function HdRequestData(props) {
    const StateData = useSelector((state) => state.authData);
    const { manager_user, staff_member, user_no } = useConfig();

    var PopupData = props.data;
    const [PopupImage, SetPopupImage] = useState(null);
    const [PopupVideo, SetPopupVideo] = useState(null);
    useEffect(() => {
        if (PopupData?.document) {
            ApiGetCDNData("/" + PopupData?.document, StateData?.Schoolnumber || props?.schoolnumber, PopupData?.school_id).then((result) => {
                try {
                    const url = URL.createObjectURL(result);
                    if (url) SetPopupImage(url);
                } catch (err) {
                    log.error(err);
                }
            });
        }

        if (PopupData?.video) {
            ApiGetCDNData("/" + PopupData?.video, StateData?.Schoolnumber || props?.schoolnumber, PopupData?.school_id).then((result) => {
                try {
                    const url = URL.createObjectURL(result);
                    if (url) SetPopupVideo(url);
                } catch (err) {
                    log.error(err);
                }
            });
        }
    }, [PopupData?.document, PopupData?.video]);
    return (
        <div>
            <div className='row px-2'>
                <div className='col-12 pb-2'>
                    <label>Ticket # : </label>&nbsp;<b>{PopupData?.request_num}</b>
                </div>
                <div className='col-12 pb-2'>
                    <label>Requester : </label>&nbsp;<b>{PopupData?.requester_type == 1 ? manager_user : staff_member}</b>
                </div>
                <div className='col-12 pb-2'>
                    <label>Help Desk Type : </label>&nbsp;<b>{PopupData?.additional_info?.type_name}</b>
                </div>
                <div className='col-12 pb-2'>
                    <label>Category : </label>&nbsp;<b>{PopupData?.additional_info?.category_name || '-'}</b>
                </div>
                <div className='col-12 pb-2'>
                    <label>Subcategory : </label>&nbsp;<b>{PopupData?.additional_info?.subcategory_name || '-'}</b>
                </div>
                <div className='col-12 pb-2'>
                    <label>Issue : </label>&nbsp;<b>{PopupData?.additional_info?.issue_name || '-'}</b>
                </div>
                <div className='col-12 py-2'>
                    <b className='h4'>Ticket Contact Details</b>
                </div>
                <hr className='mb-0' />
                <div className='col-12 py-2'>
                    <label>Subject : </label>&nbsp;<b style={{ wordWrap: "break-word" }}>{PopupData?.title || '-'}</b>
                </div>
                <div className='col-12 pb-2'>
                    <label>Name : </label>&nbsp;<b>{PopupData?.name || '-'}</b>
                </div>
                <div className='col-12 pb-2'>
                    <label>Email : </label>&nbsp;<b>{PopupData?.email || '-'}</b>
                </div>
                <div className='col-12 pb-2'>
                    <label>Room No. : </label>&nbsp;<b>
                        {PopupData?.room_name ? PopupData?.room_name : PopupData?.room ? PopupData?.room?.name : '-'}</b>
                </div>
                <div className='col-12 pb-2'>
                    <label>Building : </label>&nbsp;<b className='text-break'>{PopupData?.building_name ? PopupData?.building_name : PopupData?.building?.name}</b>
                </div>
                <div className='col-12 pb-2'>
                    <label>{user_no} : </label>&nbsp;<b>{PopupData?.student_no || '-'}</b>
                </div>
                <div className='col-12 pb-2'>
                    <label>Assigned to : </label>&nbsp;<b>{PopupData?.additional_info?.assignedtoname || '-'}</b>
                </div>
                <div className='col-12 pb-2'>
                    <label>Attached Image  : </label>&nbsp;
                    {PopupImage ?
                        <img src={PopupImage} style={{ maxHeight: '100px', maxWidth: '100%' }} className='cursor-pointer' onClick={() => props.handleShowImageModal(PopupImage)} />
                        :
                        <>-</>
                    }
                </div>
                <div className='col-12 pb-2'>
                    <label>Attached Video  : </label>&nbsp;
                    {PopupVideo ?
                        <iframe
                            width="200"
                            height="100"
                            src={PopupVideo}
                            frameborder="0"
                            allowfullscreen
                        ></iframe>
                        :
                        <>-</>
                    }
                </div>
                <div className='col-12 pb-2'>
                    <label>Description : </label>&nbsp;<b>{PopupData?.description || '-'}</b>
                </div>
            </div>
        </div>
    )
}
